import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToDays'
})
export class SecondsToDaysPipe implements PipeTransform {

  transform(value: number): number {
    return Math.floor(value / 86400);
  }

}
